const dutySchedule = {
  title: "Dienstplanung",
  createButton: "Neuer Dienstplan",
  showPast: "Vergangene Dienstpläne anzeigen",
  columns: {
    name: "Bezeichnung",
    periodStart: "Datum Von",
    periodEnd: "Datum Bis",
    status: "Status",
    workingDays: "Werktage",
    dutyCount: "Dienste",
    unfilledSlots: "Nicht besetzt",
    counselorCount: "Mitarbeiter:Innen",
    lastModified: "Geändert",
    actions: "Aktionen",
  },
  status: {
    inProgress: "In Bearbeitung",
    released: "Freigegeben",
    current: "Aktuell",
  },
  changedBy: "{{date}} durch {{user}}",
  menu: {
    release: "Freigeben",
    delete: "Löschen",
    ariaLabel: "Aktionen für {{name}}",
  },
  create: {
    dialogTitle: "Neuer Dienstplan",
    name: "Bezeichnung",
    periodStart: "Datum Von",
    periodEnd: "Datum Bis",
    overlapHint: "Der Zeitraum darf sich nicht mit einem bestehenden Dienstplan überschneiden.",
    submit: "Anlegen",
    validation: {
      periodEndAfterStart: "Datum Bis muss nach Datum Von liegen",
      periodOverlaps: "Der Zeitraum überschneidet sich mit einem bestehenden Dienstplan",
    },
    success: "Der Dienstplan wurde angelegt.",
  },
  release: {
    confirmTitle: "Dienstplan freigeben?",
    confirmText:
      "Nach der Freigabe ist der Dienstplan schreibgeschützt. Offene Änderungen werden dabei gespeichert. Nur die Teamleitung kann ihn wieder öffnen — und das nur, solange er nicht der laufende Dienstplan ist.",
    confirm: "Freigeben",
    success_one: "Der Dienstplan wurde freigegeben. {{formattedCount}} Termin wurde erstellt.",
    success_other: "Der Dienstplan wurde freigegeben. {{formattedCount}} Termine wurden erstellt.",
    inactiveCounselors:
      "Der Dienstplan kann nicht freigegeben werden. Einige Dienste sind deaktivierten Mitarbeiter:innen zugeteilt. Bitte teilen Sie diese Dienste neu zu.",
    alreadyReleased: "Der Dienstplan wurde bereits freigegeben.",
    notFound: "Der Dienstplan wurde nicht gefunden. Er wurde möglicherweise zwischenzeitlich gelöscht.",
  },
  delete: {
    confirmTitle: "Dienstplan löschen?",
    confirmText:
      "Der Dienstplan und alle darin erfassten Besetzungen werden gelöscht. Das kann nicht rückgängig gemacht werden.",
    confirm: "Löschen",
    success: "Der Dienstplan wurde gelöscht.",
  },
  edit: {
    dialogTitle: "Dienstplan bearbeiten",
    submit: "Neu berechnen",
    success: "Der Dienstplan wurde neu berechnet.",
    validation: {
      notEditable: "Ein freigegebener Dienstplan kann nicht mehr geändert werden.",
    },
  },
  detail: {
    backToList: "Zurück zur Dienstplanung",
    edit: "Bearbeiten",
    loading: "Dienstplan wird geladen",
    notCalculated: "—",
    tabsAria: "Bereiche des Dienstplans",
    tabs: {
      dataEntry: "Daten erfassen",
      counselorOverview: "Mitarbeiterübersicht",
      distribution: "Verteilung AW / BG",
    },
    keyFigures: {
      period: "Zeitraum",
    },
    dataEntry: {
      dateColumn: "Datum",
      monthTabsAria: "Monate des Dienstplans",
      tableAria: "Dienstplanungstabelle",
      noWorkingDays: "Für diesen Zeitraum wurden keine Werktage berechnet.",
      notInSession: "Kein Gerichtstag",
      unfilled: "Nicht besetzt",
      notPreferred: "Keine Wunsch-Verfügbarkeit für diesen Wochentag und Dienst oder Sperrzeitraum",
      cellAria: "{{duty}} am {{date}}, aktuell {{occupant}}",
      cellUnoccupied: "nicht besetzt",
      filter: {
        label: "Berater:innen",
        option: "{{userCode}} ({{lastName}}, {{firstName}})",
        hint: "{{matching}} von {{total}} Tagen mit Dienst von {{userCodes}}",
        highlighted: "Dienst der gefilterten Person",
      },
      picker: {
        title: "{{duty}} · {{weekday}}",
        search: "Mitarbeiter:in suchen",
        unoccupied: "— nicht besetzt —",
        noResults: "Keine Mitarbeiter:innen gefunden.",
        hours: "{{hours}} h",
        preferred: "Wunsch-Verfügbarkeit für diesen Dienst",
        assigned: "Aktuell eingeteilt",
        duty: {
          aw12: "AW 1/2",
          aw3: "AW 3",
          court: "BG",
        },
      },
      resetConfirmTitle: "Änderungen verwerfen?",
      resetConfirmText: "Alle noch nicht gespeicherten Änderungen an den Besetzungen gehen verloren.",
      saveSuccess: "Die Besetzungen wurden gespeichert.",
      lastModified: "Zuletzt bearbeitet am {{date}} um {{time}} von {{user}}",
      validation: {
        slotNotFound:
          "Der Dienstplan wurde zwischenzeitlich neu berechnet. Bitte laden Sie ihn neu und nehmen Sie die Änderungen erneut vor.",
      },
    },
    counselorOverview: {
      hint: "Anzahl der Dienste je Mitarbeiter:in — automatisch aus dem Abschnitt „Daten erfassen“ berechnet.",
      tableAria: "Mitarbeiterübersicht",
      counselorColumn: "Mitarbeiter:in",
      sumColumn: "Summe",
      totalsRow: "Gesamtergebnis",
      counselorLabel: "{{lastName}}, {{firstName}} ({{userCode}})",
    },
    distribution: {
      hint: "Soll-Verteilung der Wochenstunden je Mitarbeiter:in auf AW- und BG-Dienste — automatisch aus dem Abschnitt „Daten erfassen“ berechnet.",
      loadError: "Die Verteilung konnte nicht geladen werden. Bitte versuchen Sie es erneut.",
      table: {
        tableAria: "Verteilung AW / BG",
        counselorColumn: "Mitarbeiter:in",
        weeklyHours: "H Gesamt",
        aw12: "AW 1/2",
        aw3: "AW 3",
        aw123: "AW 1/2/3",
        bgs: "BGS",
        totalsRow: "Summe",
        counselorLabel: "{{lastName}}, {{firstName}} ({{userCode}})",
      },
      periodComparison: {
        title: "Periodenvergleich",
        tableAria: "Periodenvergleich",
        periodColumn: "Zeitraum",
        hoursColumn: "Σ H",
        currentPlan: "Aktueller Plan",
      },
      metrics: {
        title: "Kennzahlen — aktueller Plan",
        hoursPerFte: "h / VZÄ",
        hoursPerFtePerMonth: "h / VZÄ und Monat",
        bgsPerFte: "BGs / VZÄ",
      },
    },
  },
};

export default dutySchedule;
